import React from 'react';

import { PageProps, Link, graphql } from "gatsby"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import './index.scss'
import ShopifyLogo from "../../../components/images/shopify"
import ImageFooted from '../../../components/widgets/imageFooted';
import { IMG_Shopify } from '../../../components/images/docs/shopify';
import SectionNavigate from '../../../components/widgets/sectionNavigate';
import { TabEntry, Tabulator } from '../../../components/widgets/tabulator';

type DataProps = {
    site: {
        buildTime: string
    }
}

const ShopifyFacturacionCheckout: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <Layout isEcommerce={true} location={location}>
        <SEO title="FiscalPOP para eCommerce" />
        <div id='ShopifyDocs' className="_DOCS">
            <div className="integrationLogo">
                <ShopifyLogo />
            </div>
            <h2>
                Facturación en Página de Order Status (Post-compra)
            </h2>
            <p>
                Posterior a la compra, el usuario podrá consultar el estatus de su pedido en la página de Order Status.<br />
                <b>Debido a que la página de Agradecimiento no estará disponible nuevamente</b>, es importante que el cliente pueda consultar o crear su factura desde la página de Order Status.
            </p>
            <p>
                En esta vista, usuarios que hayan registrado su cuenta, o usuarios que consulten su pedido desde el link que reciben de su compra, podrán facturar su pedido. <br />
                La configuración de la página de Order Status es similar que la de Checkout (Thank You), por lo que si ya tienes configurada la página de Checkout (Thank You), las instrucciones serán familiares.
            </p>
            <ImageFooted explanation={`La imagen superior muestra la forma de facturación en el "Order Status" a la que accede el comprador y reemplaza el "Thank You" page una vez cerrada.`}>
                <IMG_Shopify file={'orderStatusBilling'} />
            </ImageFooted>
            <h3>
                Pasos para agregar la forma de facturación en "Order Status"
            </h3>
            <IMG_Shopify file={'checkoutSettingsIcon'} />
            <p>
                <b>La sección de facturación después de la compra se configura en el bloque de "Checkout" en los Settings principales de Shopify.</b><br />
                Sigue los pasos para activar el formato de facturación en la sección de "Thank You" después de la compra.
            </p>

            <Tabulator>
                <TabEntry label="Paso 1" sublabel="Ir a Configuración">
                    <ImageFooted
                        explanation={`1. Acceder a Configuración (Settings) desde tu Admin de Shopify, que se encuentra en la parte inferior izquierda.\nEn la vista de Configuración, ir al bloque que "Checkout" y en ella dar click en Customize.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onCheckoutSettings'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 2" sublabel="Acceder a Order Status">
                    <ImageFooted
                        explanation={`2. Al entrar a la sección de "Customize" del Checkout, seleccionamos la sección de "Order Status" en la parte superior y en el menú izquierdo dar click al primer ícono de "Sections" para ver las secciones disponibles a editar.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onOrderStatusConfigure'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 3" sublabel="Agregar FiscalPOP">
                    <ImageFooted
                        explanation={`3. Al dar click en el ícono de "Sections", verás las secciónes de "Order Status".\nLos links azules de "Add app Block" te permiten agregar la app de FiscalPOP en alguna de las secciónes, recomendamos en la sección de "Order Status" como en la imagen superior.\nUna vez agregada, verás el bloque que indica que "No se encontró orden con ese número".\nEsto es normal, ya que no hay una orden de prueba en la vista de configuración.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onOrderStatusAddBlock'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 4" sublabel="Guardar cambios">
                    <ImageFooted
                        explanation={`4. Una vez agregada la app, daremos click en "Save" en la parte superior izquierda para guardar los cambios realizados.\nUna vez aplicados los cambios, la forma de facturación estará disponible en Order Status.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onOrderStatusSave'} />
                    </ImageFooted>
                </TabEntry>
            </Tabulator>
            <p>
                Si necesitas orientación en configurarla, escríbenos a <a href="mailto:soporte@fiscalpop.com">soporte@fiscalpop.com</a>
            </p>
            <SectionNavigate previous={`/ecommerce/shopify/facturacion-en-checkout`} next={`/ecommerce/shopify/facturacion-en-pos`} />
        </div>
    </Layout>
)

export default ShopifyFacturacionCheckout;